import { IdPathParameters, FindOperation } from '@infuse/api/common';
import { Organisation } from '@infuse/api/iam/organisation';
import { useQuery } from '@tanstack/vue-query';
import { computed, ref } from 'vue';

export function useGenericOrganisation({
  apiFn,
  queryKeys,
  onlyEnableWithParentId = false,
  initialParentId
}: {
  apiFn: FindOperation<Organisation, string> | FindOperation<Organisation, IdPathParameters<string>>;
  queryKeys: string[];
  onlyEnableWithParentId?: boolean;
  initialParentId?: string;
}) {
  const fetchOrganisationId = ref<string | undefined>(undefined);
  const fetchParentId = ref<string | undefined>(initialParentId);

  const query = useQuery<Organisation>({
    queryKey: [...queryKeys, 'detail', fetchParentId, fetchOrganisationId],
    enabled: () => !!fetchOrganisationId.value && (onlyEnableWithParentId ? !!fetchParentId.value : true),
    queryFn: () => {
      if (onlyEnableWithParentId && fetchParentId.value) {
        return apiFn({ id: fetchParentId.value, organisationId: fetchOrganisationId.value });
      }
      return apiFn({ id: fetchOrganisationId.value });
    }
  });

  const organisation = computed(() => query.data.value);

  return {
    ...query,
    organisation,
    fetchOrganisationId,
    fetchParentId
  };
}
